"use client";

import Button from "@/components/ui/Button";
import Modal from "@/components/ui/Modal";
import { useTranslations } from "@/i18n/client";
import { routing, useGeo } from "@/i18n/routing";
import { GeoLocale } from "@frend-digital/next/i18n";
import { Dispatch, SetStateAction, useState, useTransition } from "react";
import Dropdown from "../checkout/Dropdown";
import styles from "./GeoSelector.module.css";
import { bypassGeolocation } from "@trydig/next/router";

export const GeoSelectorModal = () => {
  const t = useTranslations();
  const [isPending, startTransition] = useTransition();
  const {
    action,
    pending,
    language: initialLanguage,
    country: initialCountry,
    geo,
  } = useGeo();

  const [lang, setLang] = useState(() => initialLanguage);
  const [country, setCountry] = useState(() => initialCountry);

  const newGeo =
    `${lang || initialLanguage}-${country || initialCountry}` as GeoLocale;

  const startGeoChange = () => {
    if (newGeo === geo) {
      return;
    }
    console.log("startGeoChange", newGeo, geo);

    bypassGeolocation(true);

    startTransition(() => {
      action(newGeo);
    });
  };

  return (
    <Modal modal="geo">
      <div className={styles.modal}>
        <h2 className={styles.intro}>{t("Language & Region")}</h2>
        <Languages language={lang} setLanguage={setLang} />
        <Countries country={country} setCountry={setCountry} />
        <Button onClick={startGeoChange} disabled={pending || isPending}>
          {t("Confirm")}
        </Button>
      </div>
    </Modal>
  );
};

export interface LanguagesProps {
  language: string;
  setLanguage: Dispatch<SetStateAction<string>>;
}

export const Languages = ({ language, setLanguage }: LanguagesProps) => {
  const t = useTranslations();
  const changeLanguage = (language: string) => {
    if (!language) {
      return;
    }

    setLanguage(language);
  };

  return (
    <section>
      <p className={styles.label}>{t("Select the desired language")}</p>
      <Dropdown
        options={routing.languages.map((l) => ({
          value: l,
          label: t(l),
        }))}
        onChange={(val) => {
          if (!val) return;

          changeLanguage(val?.value);
        }}
        value={language}
      />
    </section>
  );
};

export interface CountriesProps {
  country: string;
  setCountry: Dispatch<SetStateAction<string>>;
}

export const Countries = ({ country, setCountry }: CountriesProps) => {
  const t = useTranslations();

  const changeCountry = (country: string) => {
    if (!country) {
      return;
    }

    setCountry(country);
  };

  return (
    <section>
      <p className={styles.label}>{t("Select delivery country")}</p>
      <Dropdown
        options={routing.countries.map((c) => ({
          value: c.country,
          label: c.name,
        }))}
        onChange={(val) => {
          if (!val) return;

          changeCountry(val?.value);
        }}
        value={country}
      />
    </section>
  );
};
